






































import Vue from 'vue'
import { Configuration, AdminInfoDetail, DoctorInfoRestControllerApi } from '@/types/api-docs'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import Initializer from '@/utils/initializer'
import Utils from '@/utils/utils'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  adminInfo?: AdminInfoDetail
  adminInfosId: number
  adminInfoContent: string
  isFormValid: boolean
}

const api = new DoctorInfoRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export default Vue.extend({
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      adminInfo: Initializer.initAdminInfoDetail(),
      adminInfosId: Number(this.$route.params.id),
      adminInfoContent: '',
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchAdminInfoDetail()
  },
  computed: {},
  methods: {
    async fetchAdminInfoDetail() {
      const { data } = await api.fetchMemberAdminInfoDetail(this.adminInfosId)
      this.adminInfo = data
      this.adminInfoContent = Utils.sanitizeText(this.adminInfo.content).replaceAll(/\n/g, '<br>')
    },
    formatDate(date: string, format: string) {
      return Utils.formatStringDate(date, format)
    },
  },
})
